import React from "react";
import styles from "@/styles/houseOfSenco.module.scss";
import { useFormik } from "formik";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import { toast } from "react-toastify";
import * as Yup from "yup";

const TrendUpdates = () => {
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email format"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.email.length) {
        try {
          const { data } = await httpClient.post(endpoints.auth.subscribe(), {
            ...values,
            type: "house_of_senco_page",
          });
          toast(data.message, {
            type: "success",
          });
          resetForm();
        } catch (error: any) {
          if (error.response?.data?.message) {
            toast(error.response.data.message  as string, {
              type: "error",
            });
          } else {
            toast("Something went wrong! Try again!", {
              type: "error",
            });
          }
        }
      }
    },
  });
  return (
    <div className={styles.trend_updates}>
      <div className={styles.container}>
        <p> Get trend updates, style tips and more</p>
        <form onSubmit={formik.handleSubmit}>
          <div className={styles.trend_conainer}>
            <input
              type="email"
              placeholder="YOUR EMAIL"
              {...formik.getFieldProps("email")}
            />{" "}
            <button type="submit">
              SUBSCRIBE <i className="bi bi-arrow-right"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TrendUpdates;
